import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import User from '@/repositories/data/User';
import Resource from '@/repositories/Resource';
import ApiWrapper from '@/repositories/data/ApiWrapper';
import networkBoundResource from '@/repositories/networkBoundResource';
import unwrapApiWrapper from '@/repositories/unwrapApiWrapper';
import { BehaviorSubject, Observable } from 'rxjs';
import HttpClient from '@/util/http/HttpClient';
import { switchMap } from 'rxjs/operators';

export default class UserRepository extends BaseCrudRepository<User, User, number> {
    public constructor(client: HttpClient) {
        super(client, 'api/users/', 'USERS');
    }

    public getSelf(): Observable<{ name: string } | null> {
        return this.client.get('self', { baseUrl: this.baseUrl.replace('api/users/', '') });
    }

    public findCurrent(): Observable<Resource<User>> {
        const observable = this.getSelf().pipe(
            switchMap((user) => {
                if (user) {
                    const observable = this.client.get<ApiWrapper<User>>('current', { baseUrl: this.baseUrl });
                    return unwrapApiWrapper(observable);
                }
                return new BehaviorSubject(null).asObservable();
            }),
        );
        return networkBoundResource(observable);
    }

    public keepAlive(): void {
        this.findCurrent().subscribe(() => {
            // Do nothing
        });
    }

    public logout(): Observable<Resource<{ logoutUrl: string }>> {
        const observable = this.client.post<{ logoutUrl: string }>(
            (process.env.VUE_APP_API_ENDPOINT as string).replace('/api', '') + '/oauth2/logout',
        );
        return networkBoundResource(observable);
    }
}
